/*
 * Alaluma conversion hooks.
 *
 * These events are intentionally lightweight. They give GTM/GA/Klaviyo a
 * stable dataLayer signal without requiring tracking IDs in the theme code.
 */
(function() {
  window.dataLayer = window.dataLayer || [];

  function pushEvent(eventName, payload) {
    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
  }

  function textOf(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;

    var productSection = form.closest('[data-product-handle]');
    var handle = productSection ? productSection.getAttribute('data-product-handle') : '';
    var variantInput = form.querySelector('input[name="id"]');
    var productTitle = document.querySelector('.product__title, h1');
    var priceNode = form.querySelector('[data-button-price]');

    pushEvent('add_to_cart_intent', {
      ecommerce: {
        currency: window.theme && window.theme.currencyCode,
        items: [{
          item_id: variantInput ? variantInput.value : undefined,
          item_name: textOf(productTitle),
          item_variant: variantInput ? variantInput.value : undefined,
          item_category: 'Handbags',
          item_handle: handle,
          price_label: textOf(priceNode)
        }]
      }
    });
  }, true);

  document.addEventListener('click', function(event) {
    var collectionLink = event.target.closest('a[href*="/collections/"]');
    if (!collectionLink) return;

    pushEvent('collection_click', {
      link_text: textOf(collectionLink),
      link_url: collectionLink.href,
      page_type: document.body.className
    });
  });

  document.addEventListener('click', function(event) {
    var checkoutLink = event.target.closest('a[href*="/checkout"], button[name="checkout"]');
    if (!checkoutLink) return;

    pushEvent('checkout_intent', {
      source_text: textOf(checkoutLink),
      page_type: document.body.className
    });
  });
})();

// Safety net for cached storefront HTML that still contains the old global
// sticky ATC script. The sticky product button should never appear off PDPs.
(function() {
  function removeOffProductStickyAtc() {
    if (document.body && document.body.classList.contains('template-product')) return;

    var stickyAtc = document.querySelector('.alaluma-sticky-atc');
    if (stickyAtc) stickyAtc.remove();
  }

  removeOffProductStickyAtc();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeOffProductStickyAtc);
  }

  if ('MutationObserver' in window && document.body) {
    new MutationObserver(removeOffProductStickyAtc).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  [100, 500, 1500].forEach(function(delay) {
    window.setTimeout(removeOffProductStickyAtc, delay);
  });
})();

// ---- Mobile ATC -> /cart redirect (conversion fix) ----
// theme:cart:popdown fires on [data-product-add-popdown-wrapper] WITHOUT
// bubbles:true, so document.addEventListener never hears it. Must attach
// directly to the popdown element. The element is in the DOM at page load.
(function() {
  function attachListener() {
    var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
    if (!popdown) return false;
    popdown.addEventListener('theme:cart:popdown', function() {
      if (window.innerWidth > 749) return;
      window.setTimeout(function() {
        if (window.location.pathname !== '/cart') {
          window.location.href = '/cart';
        }
      }, 350);
    });
    return true;
  }
  if (!attachListener()) {
    document.addEventListener('DOMContentLoaded', attachListener);
  }
})();

